import { GridsterItem, GridsterItemComponentInterface } from 'angular-gridster2';
import { AppMessage } from '../app-message/app-message';
import { InjectionToken, TemplateRef } from '@angular/core';
import { TabId } from '../../custom/vrgroup/train-info/train-info/train-info.component';
import { MapElement } from '../map/map-element.model';
import { Point } from 'geojson';
import { MarkerGeometry } from '../map/map.service';

export class LandingPageTileInterface {
  icon?: string;
  unread: Array<AppMessage>;
  panel?: string;
  description?: string;
  title?: string;
  x?: number;
  y?: number;
  rows: number;
  cols: number;
  initCallback?: (item: GridsterItem, itemComponent: GridsterItemComponentInterface) => void;
  dragEnabled?: boolean;
  resizeEnabled?: boolean;
  compactEnabled?: boolean;
  maxItemRows?: number;
  minItemRows?: number;
  maxItemCols?: number;
  minItemCols?: number;
  minItemArea?: number;
  maxItemArea?: number;
  component: any;
  label?: string;
  maximized?: boolean;
  iconDataFaTransform?: string;
  labelDataFaTransform?: string;
  availableOnLanding?: boolean;
  showOnSidebar: boolean;
}

export class LandingPageTile implements LandingPageTileInterface {
  id?: string;
  icon: string;
  unread: Array<AppMessage>;
  panel: string;
  description: string;
  title: string;
  /// use a template for the dialog title, instead of `title`
  titleTemplate?: TemplateRef<void>;
  x?: number;
  y?: number;
  rows: number;
  cols: number;
  initCallback?: (item: GridsterItem, itemComponent: GridsterItemComponentInterface) => void;
  onResize?: (width: number, height: number) => void;
  dragEnabled?: boolean;
  resizeEnabled?: boolean;
  compactEnabled?: boolean;
  maxItemRows?: number;
  minItemRows?: number;
  maxItemCols?: number;
  minItemCols?: number;
  minItemArea?: number;
  maxItemArea?: number;
  component: any;
  label?: string;
  maximized?: boolean;
  iconDataFaTransform?: string;
  labelDataFaTransform?: string;
  availableOnLanding?: boolean;
  showOnSidebar: boolean;
  params?: SidebarPanelParams;

  constructor(obj: LandingPageTileInterface) {
    Object.assign(this, obj);
    try {
      this.component.initTile(this);
    } catch (e) {
      console.error(obj);
      console.error(e);
    }
  }

  public getPersistedObject(): PersistedTileSetup {
    return new PersistedTileSetup({
      x: this.x,
      y: this.y,
      rows: this.rows,
      cols: this.cols,
      maxItemRows: this.maxItemRows,
      maxItemCols: this.maxItemCols,
      maximized: this.maximized,
    });
  }
}

export class PersistedTileSetup {
  x?: number;
  y?: number;
  rows: number;
  cols: number;
  maxItemRows?: number;
  maxItemCols?: number;
  maximized: boolean;

  constructor(obj: PersistedTileSetup) {
    Object.assign(this, obj);
  }
}

export const ELEMENT_STATE_NAME = new InjectionToken<string>('Name for state entries');

export interface SidebarPanelParams {
  feature?: MapElement<MarkerGeometry>;
  openTab?: TabId;
}

export const ELEMENT_PARAMETERS = new InjectionToken<SidebarPanelParams>('Element info params');
